export default __webpack_public_path__ + "static/media/red-vista.13eb1cf4.png";